export default __webpack_public_path__ + "static/media/one-view.6f32e134.svg";